<template>
  <LoginSignupComboForm
    @success="next"
    :longform="true"
    titleAlignment="left"
    :enableBack="true"
    :backAction="back"
  />
</template>

<script>
import { onMounted, ref } from "@vue/composition-api";
import LoginSignupComboForm from "@/components/smart/forms/LoginSignupComboForm";
import store from "@/store";
import useAnalytics from "@/utils/useAnalytics";

export default {
  name: "CheckoutProfilePage",
  components: {
    LoginSignupComboForm,
  },
  setup(props, { root }) {
    const errors = ref(null);
    const loading = ref(false);

    // go to previous checkout step
    const back = () => {
      root.$router.push({
        name: "checkout-package",
        query: store.getters["checkout/getQueryParams"],
      });
    };

    const { cartData } = useAnalytics();

    // create user and go to next checkout step
    const next = () => {
      store.dispatch("analytics/send", { name: "checkoutTermsAgreement", data: cartData.value });
      store.dispatch("analytics/send", { name: "checkoutSignup", data: cartData.value });
      errors.value = false;
      root.$router.push({
        name: "checkout-details",
        query: store.getters["checkout/getQueryParams"],
      });
    };

    onMounted(() => {
      if (!store.state.checkout.appId || !store.state.checkout.packageId) {
        back();
      } else if (store.getters["auth/isLoggedIn"]) {
        next();
      }
    });

    return {
      next,
      back,
      errors,
      loading,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables";
</style>
